import React from 'react';
import styled, { css } from 'styled-components';
import { Grid } from 'core/components';
import { lighten, darken } from 'polished';

const ResultItemSelectedStyles = (props) =>
  props.selected &&
  css`
    background: ${({ theme }) => `${darken(0.2, theme.colors.primary)}`};

    .title,
    .description {
      color: #ffffff;
    }

    .bp4-icon {
      color: ${({ theme }) => `${lighten(0.4, theme.colors.primary)}`};
    }
  `;

const ResultItemSharedStyles = css`
  grid-template-columns: min-content 1fr max-content;
  border-radius: 4px;
  align-items: center;

  .bp4-icon {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const ResultItem = styled(Grid)`
  grid-template-rows: 1fr minmax(1fr, 3fr);
  grid-template-areas:
    'icon title rightIcon'
    'icon description rightIcon';

  ${(props) => ResultItemSelectedStyles(props)}
  ${ResultItemSharedStyles}
`;

const ResultItemSingleRow = styled(Grid)`
  grid-template-rows: max-content;
  grid-template-areas: 'icon title rightContent';
  align-items: center;

  ${(props) => ResultItemSelectedStyles(props)}
  ${ResultItemSharedStyles}
`;

function ResultMenuItem(props) {
  return <ResultItem tabIndex={0} gridGap={1} gridRowGap={0} p="4px" {...props} />;
}

function ResultMenuItemSingleRow(props) {
  return <ResultItemSingleRow tabIndex={0} gridGap={1} gridRowGap={0} p="4px" {...props} />;
}

export { ResultMenuItemSingleRow };
export default ResultMenuItem;
